import { Icon } from '@iconify/react'
import { Modal, TabPane, Tabs } from '@pepper/ui'

import Uploader from './Uploader'
import ManualForm from './ManualForm'

import s from './ImportModal.module.css'

type Props = {
  companyId: string
  projectId: string
  open: boolean
  onClose: () => void
  domainRegion: string
  setIsAddingBulkTopics: (value: boolean) => void
}

export const ImportModal: React.FC<Props> = ({
  open,
  onClose,
  companyId,
  projectId,
  domainRegion,
  setIsAddingBulkTopics,
}) => {
  return (
    <Modal
      visible={open}
      title={null}
      onCancel={onClose}
      destroyOnClose={true}
      closeIcon={null}
      footer={null}
      className={s.wrapper}
    >
      <Tabs>
        <TabPane
          key="ADD"
          tab={
            <div className={s.tabTitle}>
              <Icon icon="lucide:plus" width={18} height={18} />
              Add a Topic
            </div>
          }
        >
          <ManualForm
            companyId={companyId}
            projectId={projectId}
            domainRegion={domainRegion}
            onClose={onClose}
            setIsAddingBulkTopics={setIsAddingBulkTopics}
          />
        </TabPane>
        <TabPane
          key="UPLOAD"
          tab={
            <div className={s.tabTitle}>
              <Icon icon="lucide:upload" width={18} height={18} />
              Upload Topics
            </div>
          }
        >
          <Uploader
            companyId={companyId}
            projectId={projectId}
            onClose={onClose}
            setIsAddingBulkTopics={setIsAddingBulkTopics}
          />
        </TabPane>
      </Tabs>
    </Modal>
  )
}
